import React, {Component} from 'react';
import LoadingSpinner from "../Utils/LoadingSpinner";
import {Form, Formik} from "formik";
import {HW_DRIVER_URL} from "../Const";

const DeviceRegistrationForm = (props) => {

    return ( <div>
        <h1>Device Registration</h1>
        <Formik
            initialValues={{agreement_id:props.agreements[0].id}}
            onSubmit={ (values) => {
                props.onFormSubmission(values);
            }}
        >
            {({
                  values,
                  handleChange,
                  handleBlur,
                  isSubmitting,
              }) => (
                <Form>
                    Agreement
                    <select name="agreement_id" value={values.agreement_id} onChange={handleChange}
                            onBlur={handleBlur} >
                        { props.agreements.map( agreement => (<option value={agreement.id}
                                                                       key={agreement.id}
                                                                      label={agreement.name} />))}
                    </select>
                    <button type="submit" disabled={isSubmitting}>
                        Register Device
                    </button>
                </Form>
            )}
        </Formik>
    </div>);
};

class ManufacturerPortal extends Component {
    state = {
        loading: true
    };

    componentDidMount() {
        this.props.simGps.getPartnerAgreements(
            (success, result) => {
                if(success){
                    this.setState({loading:false, agreements: result})
                }else{
                    this.setState({loading:false})
                }
            }
        );
    }

    onFormSubmission = (values) => {
        console.log(values);
        const init = {
            method: "POST",
            body: JSON.stringify(
                {command: 'register',
                agreement_id:values.agreement_id}
                ),
        };

        init.mode = 'cors';
        init.cache = 'default';

        fetch(HW_DRIVER_URL, init)
            .then(res => res.json())
            .then(() => {
                    console.log("Posted");
                },
                (error) => {
                    console.log(JSON.stringify(error));
                }
            );

    };

    render() {
        console.log("registration_done:", this.props.registration_done);
        console.log("registration_ok:", this.props.registration_ok);

        if (this.state.loading) {
            return (<LoadingSpinner text="Retrieving agreements ..."/>);
        } else {
            if ( this.props.registration_done) {
                if ( this.props.registration_ok ) {
                    return (<p> Device is registered </p>)
                }else{
                    return (<p> Registration failed </p>)
                }
            }else{
                return (<DeviceRegistrationForm {...this.props} agreements={this.state.agreements}
                                                onFormSubmission={this.onFormSubmission}
                />);

            }
        }
    }
}

export default ManufacturerPortal;
